module.exports = __webpack_public_path__ + "img/PtownFlags_06.957cd99f.png";